import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { verifyEmail } from "@/services/auth";

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Missing verification token.");
      return;
    }
    verifyEmail(token)
      .then((res) => {
        setStatus("success");
        setMessage(res.message);
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.detail || "Verification failed.");
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 text-slate-800 dark:text-slate-100">
      <div className="max-w-sm mx-auto pt-20 px-6 pb-12">
        {status === "loading" && (
          <p className="text-sm text-slate-500 dark:text-slate-400">Verifying…</p>
        )}
        {status === "success" && (
          <>
            <h1 className="text-2xl font-bold mb-4 text-slate-900 dark:text-slate-100">
              Email verified!
            </h1>
            <p className="text-sm text-slate-600 dark:text-slate-400 mb-4">{message}</p>
            <a href="/login" className="text-accent hover:text-accent-hover text-sm">
              Sign in now
            </a>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="text-2xl font-bold mb-4 text-slate-900 dark:text-slate-100">
              Verification failed
            </h1>
            <p role="alert" className="text-sm text-error mb-4">
              {message}
            </p>
            <a href="/login" className="text-accent hover:text-accent-hover text-sm">
              Back to sign in
            </a>
          </>
        )}
      </div>
    </div>
  );
}
